module.exports = __webpack_public_path__ + "img/suo.d3a3854a.png";